import {client} from '@core/GraphQLProvider';
import {GetGuestToken, GetUserAuthToken} from './query.graphql';

const Authentication = {
    async getGuestToken () {
        const resp = await client.query( {
            fetchPolicy: 'network-only',
            query: GetGuestToken
        } );

        return resp.data.guestToken;
    },

    async getUserAuthToken ( login, password, fakeRole = '' ) {

        const payload = {login, password, fakeRole};

        const resp = await client.query( {
            fetchPolicy: 'network-only',
            query: GetUserAuthToken,
            variables: payload
        } );

        return resp.data.customerToken;
    }
};

export default Authentication;